/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {isSCIDevice} from '@ion/core/src/services/ArcGISUtils';
import ControlRenderer, {Else, If} from '@ion/dls/src/render/ControlRenderer';
import {OnFindNearByProps} from '../FindNearByPopupContent';
import AssetDetailPopup from './AssetDetailPopup';
import DeviceDetailPopup from './DeviceDetailPopup';

export interface SelectedAssetPopupContentProps {
  asset: any;
  onFindNearBySubmit: (props: OnFindNearByProps) => void;
  onCancelFindNearBy: () => void;
  showFindNearBy?: boolean;
}

/**
 * @SelectedAssetPopupContent
 * Functional to display ionVision or asset detail based on the tab selection. By default Asset details is displayed.
 * find nearby.
 * 
 *  ```typescript
 * 
 *   import SelectedAssetPopupContent from '@/routes/tracking/maps/SelectedAssetPopupContent';
 * 
 *   <SelectedAssetPopupContent asset={asset} showFindNearBy={false} onFindNearBySubmit={function(){}}/>
 * 
 *  ```
 */
const SelectedAssetPopupContent = ({
  asset,
  showFindNearBy,
  onFindNearBySubmit,
  onCancelFindNearBy
}: SelectedAssetPopupContentProps) => {
  const isAsset = !isSCIDevice(asset);
  return (
    <ControlRenderer condition={isAsset}>
      <If>
        <AssetDetailPopup asset={asset}
          showFindNearBy={showFindNearBy}
          onFindNearBySubmit={onFindNearBySubmit}
          onCancelFindNearBy={onCancelFindNearBy} />
      </If>
      <Else>
        <DeviceDetailPopup selectedDevice={asset}
          showFindNearBy={showFindNearBy}
          onFindNearBySubmit={onFindNearBySubmit}
          onCancelFindNearBy={onCancelFindNearBy} />
      </Else>
    </ControlRenderer>
  );
};

export default SelectedAssetPopupContent;
